<template>
  <div>
    <v-row>
      <v-col cols="12" class="my-0 py-0">
        <v-btn @click="restartSession" text class="custom-btn">
          <span class="btn-p"><v-icon large>mdi-restart</v-icon></span>
          <span class="btn-font" v-html="sessionLabel"></span>
        </v-btn>

<!--        <v-btn-->
<!--          @click="request"-->
<!--          :to="url"-->
<!--          :target="target"-->
<!--          text-->
<!--          class="custom-btn"-->
<!--        >-->
<!--          <span class="btn-p"-->
<!--            ><v-icon large>mdi-ip-network-outline</v-icon></span-->
<!--          >-->
<!--          <span class="btn-font" v-html="setLabel"></span>-->
<!--        </v-btn>-->

        <v-btn
          @click="removeStaticIP('')"
          :disabled="!userService.radiusStaticIp"
          text
          class="custom-btn"
        >
          <span class="btn-p"
            ><v-icon class="mr-1" large>mdi-trash-can</v-icon></span
          >
          <span class="btn-font">Remove<br />Static<br />IP</span>
        </v-btn>
        <v-btn
          @click="triggerConfirmStaticIp(userService.ipGroup)"
          :disabled="userService.radiusStaticIp != '' && userService.radiusStaticIp != null
          || userService.ipRange != '' && userService.ipRange != null"
          text
          class="custom-btn"
        >
          <span class="btn-p"
            ><v-icon class="mr-1" large>mdi-access-point-plus</v-icon></span
          >
          <span class="btn-font">New<br />Static<br />IP</span>
        </v-btn>

        <v-btn
          @click="triggerConfirmIpRange(userService.ipGroup)"
          :disabled="userService.radiusStaticIp == '' || userService.radiusStaticIp == null
          || userService.ipRange != '' && userService.ipRange != null || userService.isIPoE"
          text
          class="custom-btn"
        >
          <span class="btn-p"
          ><v-icon class="mr-1" large>mdi-access-point-plus</v-icon></span
          >
          <span class="btn-font">New<br />Routed<br />Subnet</span>
        </v-btn>

        <v-btn
          @click="removeStaticIP(userService.ipRange)"
          :disabled="!userService.ipRange"
          text
          class="custom-btn"
        >
          <span class="btn-p"
          ><v-icon class="mr-1" large>mdi-trash-can</v-icon></span
          >
          <span class="btn-font">Remove<br />Routed<br />Subnet</span>
        </v-btn>

        <v-btn
          v-if="ipoeEnabled"
          @click="triggerConfirmSwitchProtocol"
          text
          class="custom-btn"
        >
          <span class="btn-p"
          ><v-icon class="mr-1" large>mdi-toggle-switch-outline </v-icon></span
          >
          <span class="btn-font">Switch<br />Network<br />Protocol</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="staticIpDialog" persistent max-width="510">
      <v-card>
        <v-card-title class="headline">Confirm Add Static Ip</v-card-title>
        <v-card-text>Please Confirm Add Single Static Ip</v-card-text>
        <v-card-actions>
          <v-btn color="darken-1" @click="requestNewStaticIP('')">Confirm</v-btn>
          <v-btn color="darken-1" @click="closeStaticIpDialog()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ip-range
      :dialog="ipRangeDialog"
      :text="
        `Please Choose Ip Range to proceed`
      "
      :isIPoE="userService.isIPoE"
      @onBtnClick="requestNewStaticIP"
      @onClose="closeIpRangeDialog"
    ></ip-range>

    <warning
      :dialog="switchProtocolWarningDialog"
      :text="protocolWarningText"
      :cancelText="`Ok`"
      @onBtnClick="closeWarningDialog"
    ></warning>

    <confirm
      :dialog="switchProtocolDialog"
      :text="`You are about to switch the network protocol. Do you want to proceed?`"
      :proceedText="`Yes, proceed`"
      :cancelText="`Cancel`"
      @onBtnClick="switchNetworkProtocol"
    ></confirm>
  </div>
</template>

<script>
export default {
  name: "edit-actions",
  props: {
    isAdding: { type: Boolean, required: true },
    url: { type: String, required: true },
    target: { type: String, required: true },
    getIP: { type: String, required: false },
    userService: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  data: () => ({
    sessionLabel: "Restart<br/>Session",
    ipRangeDialog:false,
    staticIpDialog:false,
    switchProtocolDialog:false,
    switchProtocolWarningDialog:false,
    protocolWarningText:"",
  }),
  methods: {
    request() {
      let vm = this;
      vm.$emit("request");
    },
    restartSession() {
      let vm = this;
      vm.$emit("restartSession");
    },
    requestNewStaticIP(ipGroup){

      let vm = this;
      vm.requestIP(ipGroup).then(data => {
        vm.userService.radiusStaticIp = data;
        vm.ipRangeDialog = false;
        vm.staticIpDialog = false;
      })
      .catch(() => {
        vm.userService.radiusStaticIp = null
        vm.ipRangeDialog = false;
        vm.staticIpDialog = false;
      });

    },
    closeStaticIpDialog(){
      let vm = this;
      vm.staticIpDialog = false;
    },
    closeIpRangeDialog(){
      let vm = this;
      vm.ipRangeDialog = false;
    },
     removeStaticIP(ipRange) {
        let vm = this;
        let removedMsg = "";
        const s = "Static IP removed successfully";
        vm.removeIP(ipRange).then((data) => {
            if (data.data.toLowerCase().includes(s.toLowerCase())) {
                removedMsg = data.data;
                vm.$store.dispatch("httpResponse/setHttpResponse",
                    { text: removedMsg, color: "success" },
                    { root: true });
            }

            vm.userService.radiusStaticIp = null;
        });
     },
    triggerConfirmIpRange(args) {
      let vm = this;
      vm.ipRangeDialog = true;
    },
    triggerConfirmStaticIp(args) {
      let vm = this;
      vm.staticIpDialog = true;
    },
    triggerConfirmSwitchProtocol(){
      let vm =this;
      if((!vm.userService.serviceId || !vm.userService.serviceId.includes("AVC")) && !vm.userService.isIPoE)
      {
        vm.protocolWarningText = "This service does not have AVC id, please add AVC id to this service before switching to IPoE Protocol";
        vm.switchProtocolWarningDialog = true;
      } else if(vm.userService.radiusStaticIp || vm.userService.ipRange){
        vm.protocolWarningText = "This service has static ip, please remove static ip from this service before switching network protocol";
        vm.switchProtocolWarningDialog = true;
      } else {
        vm.switchProtocolDialog = true;
      }
    },
    switchNetworkProtocol(args){
      let vm = this;
      if (args) {
        vm.switchProtocol().then(data => {
          vm.switchProtocolDialog = false;
          vm.userService.isIPoE = !vm.userService.isIPoE;
        }).catch(() => {
            vm.switchProtocolDialog = false;
          });
      }
      vm.switchProtocolDialog = false;
    },
    closeWarningDialog(){
      let vm = this;
      vm.switchProtocolWarningDialog = false;
    },
  },
  computed: {
    setLabel() {
      let vm = this;
      if (
        vm.userService.kayakoConversation !== "" ||
        vm.userService.kayakoConversation !== null
      )
        return "Request<br/>Static IP<br/>Range";
      else return "View<br/>Kayako<br/>Ticket";
    },
    ipoeEnabled() {
      let vm =this;
      let flags = vm.$store.getters["featureFlag/allFlags"];
      return flags.sog5822;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
